import HeaderSignIn from "../../components/headers/HeaderSignIn";
import { Box, Container, Typography } from "@mui/material";
import React from "react";

const SignUpCompletePage: React.FC = () => {
  sessionStorage.clear();
  return (
    <>
      <HeaderSignIn />
      <Container maxWidth={"xl"}>
        <Box textAlign="center" mt={15}>
          <Typography variant="h5" gutterBottom>
            ユーザー登録完了
          </Typography>
        </Box>
        <Box mt={5} textAlign="center">
          <Typography variant="body1" gutterBottom>
            登録したメールアドレスに認証キーを送付しました。
            <br />
            ログイン後、プラグインダウンロード画面からプラグインをダウンロードしお使いのkintoneに反映してください。
            <br />
            kintoneプラグインの設定画面で認証キーを登録することができます。
          </Typography>
        </Box>
      </Container>
    </>
  );
};

export default SignUpCompletePage;
